<template>
  <el-dialog
    title="Cuidado!"
    :visible.sync="dialogFormVisible"
    width="24.1%"
    top="15%"
    :append-to-body="true"
    @close="onDialogCancelationClose('formContractCancelationWarning')"
  >
    <el-row>
      <el-alert
        title="Lee Atentamente: "
        type="warning"
        show-icon
        effect="light"
        :closable="false"
      >
        Estas apunto de cerrar este contrato en navision y de generar un ticket
        de desinstalacion para todas sus lineas de contrato,
        <br />asi como para desactivar el usuario del cliente en navixy.
        <br /><br />
        <strong>Seguro que desea continuar?</strong>
      </el-alert>
    </el-row>
    <el-row>
      <el-form
        ref="formContractCancelationWarning"
        :model="formContractCancelationWarning"
        :rules="ContractCancelationRules"
      >
        <el-form-item label="Motivo de cierre: " prop="statusContract">
          <el-select
            v-model="formContractCancelationWarning.statusContract"
            placeholder="Seleccione motivo cierre de contrato"
            size="small"
          >
            <el-option
              v-for="item in ContractCancellationOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </el-row>

    <span slot="footer" class="dialog-footer" type="flex" justify="end">
      <el-button
        @click="
          onDialogCancelationClose('formContractCancelationWarning', true)
        "
        >Cancelar</el-button
      >
      <el-button
        type="primary"
        @click="onCancelationConfirmation('formContractCancelationWarning')"
        >Confirmar</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "ContractCancellationWarning",
  props: {
    ConfimrContractCancellationView: {
      type: Boolean,
      default: false
    },
    CurrentActionData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      formContractCancelationWarning: {
        statusContract: ""
      },
      ContractCancellationOptions: [
        {
          label: "Suspendido por Pago",
          value: 2
        },
        {
          label: "Cerrado por Legal",
          value: 3
        },
        {
          label: "Cerrado por Clientes",
          value: 4
        }
      ],
      ContractCancelationRules: {
        statusContract: [
          {
            required: true,
            message:
              "Debe seleccionar un motivo por el cual se cerrará el contrato",
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {
    dialogFormVisible() {
      return this.ConfimrContractCancellationView;
    }
  },
  methods: {
    onDialogCancelationClose(formName, fromCancel = false) {
      this.$refs[formName].resetFields();
      this.$emit(
        "onDialogContractCancelationClose",
        false,
        this.CurrentActionData,
        fromCancel
      );
    },
    onCancelationConfirmation(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit(
            "onContractCancelationConfirmation",
            this.formContractCancelationWarning.statusContract,
            this.CurrentActionData
          );
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style></style>
